/*
 * @Author: Wu Yinglei
 * @Date: 2021-01-12 17:10:27
 * @LastEditors: Wu Yinglei
 * @LastEditTime: 2021-08-16 10:28:03
 * @Description: rem.js
 * @FilePath: \lab820\src\libs\rem.js
 */

(function (doc, win) {
  const docEl = doc.documentElement
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  const recalc = function () {
    var clientWidth = docEl.clientWidth
    var docbody = doc.body
    if (!clientWidth) return
    docEl.style.fontSize = 200 * (clientWidth / 750) + 'px'
    // docbody.style.height = (win.screen.height / (100 * (clientWidth / 750))) - 1.28 + 'rem'
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)

// (function(doc, win) {
//   console.log(doc)
//   var docEl = doc.documentElement,  //getElementById("luckDraw")
//       resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
//       recalc = function() {
//           var clientWidth = docEl.clientWidth;
//           //if (!clientWidth) return;
//           if(clientWidth<600){
//               var width = clientWidth;
//           }else{
//               var width = 600;
//           }
//           docEl.style.fontSize = 20 * (width / 320) + 'rpx';
//           //宽与高度
//           //document.body.style.height = clientWidth * (900 / 1440) + "rpx"
//       };
      
//   win.addEventListener(resizeEvt, recalc, false);
//   doc.addEventListener('DOMContentLoaded', recalc, false);
// })(document, window)



// WEBPACK FOOTER //
// ./src/libs/rem.js